import { render, staticRenderFns } from "./CColorPicker.vue?vue&type=template&id=303ca07a&"
import script from "./CColorPicker.vue?vue&type=script&lang=ts&"
export * from "./CColorPicker.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports